// ?conversation=<id> deep link (LAND-2026-09-28-B item 6).
//
// The recruiter-agent escalation email and the pt-agents morning brief both link a
// thread as https://crm.protherapystaffing.com/?conversation=<agent_conversations.id>.
// This is the CRM half: open that thread straight away.
//
// RULES:
//   * The id is read ONLY from that one parameter, and only when it is a well-formed
//     UUID (agent_conversations.id is a uuid). Anything else -- empty, junk, markup, a
//     second value -- is ignored: the recruiter lands on the normal view, never an error.
//   * A well-formed id that matches no loaded conversation is ignored the same way.
//   * The id is never written to a log (App.jsx has no console call on this path;
//     conversationDeepLink.test.js pins that).
//
// PURE, like the other ./lib modules.

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** The conversation id from a location.search string, or null. */
export function parseConversationParam(search) {
  let params;
  try {
    params = new URLSearchParams(String(search || ''));
  } catch {
    return null;
  }
  const all = params.getAll('conversation');
  if (all.length !== 1) return null;
  const id = all[0].trim();
  return UUID.test(id) ? id.toLowerCase() : null;
}

/** The loaded conversation for that id, or null (unknown -> normal view). */
export function findConversationById(conversations, id) {
  if (!id) return null;
  const want = String(id).toLowerCase();
  return (conversations || []).find((cv) => cv && String(cv.id).toLowerCase() === want) || null;
}

/** The search string with the conversation parameter removed ('' or '?a=b'). */
export function withoutConversationParam(search) {
  const params = new URLSearchParams(String(search || ''));
  params.delete('conversation');
  const s = params.toString();
  return s ? `?${s}` : '';
}
